import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "PhD Applicant",
          "AI Research Engineer",
          "Deep Learning Researcher",
          "Biomedical AI Specialist",
          "Algorithm Designer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
